export default __webpack_public_path__ + "static/media/a023-05.050b1860.png";